<template>
    <div>
        <div class="title">
            <h4>提现说明</h4>
        </div>
        <!-- 搜索框 -->
        <!-- <div class="searchBox" ref="searchBox">
            <el-form :inline="true" :model="table.searchForm" ref="searchForm" class="demo-form-inline" label-width="100px" size="mini">
                <div class="inpBox">
                    <el-form-item label="项目名称: " prop="name">
                        <el-input placeholder="" v-model="table.searchForm.name"></el-input>
                    </el-form-item>
                </div>
                <div class="searchBtnBox">
                    <el-form-item>
                        <el-button type="primary" @click="tableSearch">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="tableResetForm">重置</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="editDialogOpen">创建</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div> -->
        <div class="table" :style="{ height: table.height }">
            <el-table :data="table.tableList" ref="table" v-loading="table.loading" @row-click="tableHandleRowClick" highlight-current-row bordersize="mini" height="100%" style="width: 100%" center border>
                <el-table-column fixed type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="title" min-width="120" label="名称"></el-table-column>
                <el-table-column prop="icon" min-width="120" label="推广分成比例">
                    <template slot-scope="scope">
                        <div v-if="scope.row.id==1">
                            {{scope.row.percentage?scope.row.percentage*100:0}}%
                        </div>
                        
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <div>
                            <!-- <el-button type="text" size="mini" v-show="scope.row.status == 0" @click="editStatus(scope.row, 1)">禁用</el-button> -->
                            <!-- <el-button type="text" size="mini" v-show="scope.row.status == 1" @click="editStatus(scope.row, 0)">恢复</el-button> -->
                            <el-button type="text" size="mini" @click="editDialogEdit(scope.row)">编辑</el-button>
                            <!-- <el-button type="text" size="mini" @click="serviceDelete(scope.row)">删除</el-button> -->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- <div>
            <el-pagination background @size-change="pagerHandleSizeChange" @current-change="pagerHandleCurrentChange" :current-page="table.searchForm.pageNo" :page-sizes="[10, 20, 50, 100]" :page-size="table.searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="table.total"> </el-pagination>
        </div> -->
        <!-- 新建或编辑弹窗 -->
        <el-dialog :title="editDialog.title" :close-on-click-modal="false" :close-on-press-escape="false" class="vehm" :visible.sync="editDialog.visible" @close="editDialogClose" @opened="editDialogOpen" width="700px" center>
            <span>
                <el-form :inline="false" :rules="editDialog.rules" :model="editDialog.form" ref="editDialogForm" label-width="100px" class="demo-form-inline jiaoyan" size="mini">
                    <el-form-item label="名称:" prop="title" >
                        <el-input placeholder="" v-model="editDialog.form.title" style="width: 150px"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="内容:" prop="content">
                        <quill-editor v-maxWindow class="ql-editor editor"  v-model="editDialog.form.content"
                          ref="myQuillEditor" :options="editorOption"
                          style="padding: 0px;margin-bottom: 70px;overflow:visible;">
                      </quill-editor>
                    </el-form-item>
                    <el-form-item label="推广分成比例:" v-if="editDialog.form.id==1">
                        <el-input placeholder="" v-model="editDialog.form.percentage" style="width: 150px"></el-input>%
                    </el-form-item>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialog.visible = false">取消</el-button>
                <el-button type="primary" @click="editDialogSave">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    /* eslint-disable */
    import { searchcashbackDescribe, cashbackDescribeAdd, cashbackDescribeEdit, serviceDelete,uploadImg } from "@/api/request";
    import { Message } from "element-ui";
    import { toolbarOptions } from "./toolbar";
    // import Quill from 'quill';
    // import ImageResize from 'quill-image-resize-module';
    // Quill.register('modules/imageResize', ImageResize);
    export default {
        data() {
            return {
                fileList: [],
                limit:0,
                table: {
                    height: "500px",
                    loading: false,
                    total: 0,
                    tableList: [],
                    searchForm: {
                        pageNo: 1,
                        pageSize: 10,
                    },
                },
                editDialog: {
                    title: "新增说明",
                    operation: "add",
                    form: {
                        percentage:'',
                        bannerImg:[],
                        content:'',
                        title:''
                    },
                    visible: false,
                    genderList: [
                        { value: 0, label: "男" },
                        { value: 1, label: "女" },
                        { value: 2, label: "保密" },
                    ],
                    roleList: [
                        { value: 1, label: "管理员1" },
                        { value: 2, label: "管理员2" },
                        { value: 3, label: "管理员3" },
                    ],
                    rules: {
                        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
                        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                        title: [{ required: true, message: "请输入说明标题", trigger: "blur" }],
                        district: [{ required: true, message: "请输入所属区域", trigger: "blur" }],
                    },
                },
                editorOption: {
                    modules: {
                        // 工具栏定义的
                        toolbar: {
                            container: toolbarOptions,
                            handlers: {
                                image: this.imageHandler
                            }
                        },
                        // 调整图片大小
                        // imageResize: {
                        //     displayStyles: {
                        //         backgroundColor: "black",
                        //         border: "none",
                        //         color: "white",
                        //     },
                        //     modules: ["Resize", "DisplaySize", "Toolbar"],
                        // },

                    },
                    // 主题
                    theme: "snow",
                    placeholder: "请输入正文",

                },
            };
        },
        created() {
            this.tableGetList(this.table.searchForm);
        },
        computed:{
            editor() {
                return this.$refs.myQuillEditor.quill;
            },
        },
        mounted() {},
        methods: {
            //修改富文本图片格式
            imageHandler() {
                // 创建一个input类型为file的元素
                const input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.click();
                // 当用户选择文件后触发
                input.onchange = () => {
                    const file = input.files[0];
                    if (file) {
                        console.log(file);
                        // 这里需要实现将文件上传到服务器的逻辑
                        const formData = new FormData();
                        formData.append('image', file);
                        uploadImg(formData).then(
                            (res) => {
                                console.log(res);
                                const range = this.$refs.myQuillEditor.quill.getSelection();
                                this.$refs.myQuillEditor.quill.insertEmbed(range.index, 'image', res.data[0].url);
                            }
                        )
                    }
                };
            },
            // 编辑窗口: 关闭对话框后(渲染结束)执行. 恢复窗口初始状态
            editDialogClose() {
                this.$nextTick(() => {
                    this.editDialog.form.content='';
                    this.editDialog.form.percentage='';
                    this.editDialog.form.title='';
                    this.editDialog.form.bannerImg=[];
                    this.editDialog.title = "新增服务";
                    this.editDialog.operation = "add";
                    this.$refs.editDialogForm.clearValidate();
                });
            },
            // 编辑窗口: 打开. 通用设置
            editDialogOpen() {
                this.editDialog.visible = true;
            },
            // 编辑窗口: 编辑. 同时触发editDialogOpen()
            editDialogEdit(row) {
                console.log(row);
                this.editDialog.title = "编辑说明";
                this.editDialog.visible = true;
                this.editDialog.operation = "edit";
                // this.editDialog.form = row;
                // this.editDialog.form.bannerImg = JSON.parse(row.bannerImg)
                this.editDialog.form.content = row.content
                this.editDialog.form.percentage = row.percentage*100
                this.editDialog.form.title = row.title,
                this.editDialog.form.id = row.id
            },
            // 图片发生改变时，获取图片url
            handleChange(file, fileList) {
                console.log(fileList, "获取图片路径");
                fetch(fileList[0].url)
                    .then(response => response.blob())
                    .then(blob => {
                        // 创建File对象
                        const files = new File([blob], file.name, { type: "image/png" });
                        // 在这里可以对file对象进行进一步处理或者上传操作
                        const formData = new FormData();
                        formData.append('file', files);
                        console.log(formData);
                        uploadImg(formData).then(
                            (res) => {
                                console.log(res);
                                this.editDialog.form.icon = res.data[0].url
                                this.$refs.upload1.clearFiles();
                            },
                            (res) => {
                                this.$message({
                                    message: "上传失败!",
                                });
                            }
                        )
                    })
                    .catch(error => {
                        console.error('转换失败：', error);
                    });

            },
            // 图片发生改变时，获取轮播图url
            handleChanges(file, fileList) {
                console.log(fileList);
                const arr = fileList.map(item => {
                    return {
                        name: item.url,
                        value: item.name
                    };
                });
                console.log(arr);
                const requests = arr.map(url =>
                    fetch(url.name)
                        .then(response => response.blob()) // 从响应中获取Blob对象
                        .then(blob => new File([blob], url.value, { type: 'image/png' })) // 创建File对象
                );
                // 等待所有的fetch操作完成
                Promise.all(requests)
                    .then(files => {
                        // 此时 `files` 是一个包含所有 File 对象的数组
                        const formData = new FormData();
                        // 为每个 File 对象创建表单条目
                        files.forEach((file, index) => {
                            formData.append('file' + index, file);
                        });
                        console.log(formData, 123456);
                        // 现在可以发送 formData 到服务器
                        // 确保 `uploadImg` 函数返回一个 Promise
                        return uploadImg(formData).then(
                            (res) => {
                                console.log(res);
                                if (this.editDialog.form.bannerImg) {
                                    const list = res.data.map(item => {
                                        return item.url
                                    })
                                    this.editDialog.form.bannerImg.push(...list)
                                    this.$refs.upload.clearFiles();
                                } else {
                                    this.editDialog.form.bannerImg = res.data.map(item => {
                                        return item.url
                                    })
                                    this.$refs.upload.clearFiles();
                                    
                                }
                                console.log(this.editDialog.form.bannerImg);
                            },
                            (res) => {
                                this.$message({
                                    message: "上传失败!",
                                });
                            }
                        );
                    })
                    .catch(error => {
                        console.error('上传失败:', error);
                    });
            },
            //轮播图图片删除
            delFn(index) {
                this.editDialog.form.bannerImg.splice(index, 1)
                this.$refs.upload.clearFiles();
            },
            editDialogDelete(row) {},
            editDialogSave() {
                this.$refs.editDialogForm.validate((valid) => {
                    if (valid) {
                        // 全屏遮罩. 不是表格遮罩
                        const loading = this.$loading({
                            lock: true,
                            text: "正在处理...",
                        });
                        if (this.editDialog.operation == "add") {
                            //数据处理
                            let obj = {
                                name:this.editDialog.form.name,
                                bannerImg:JSON.stringify(this.editDialog.form.bannerImg),
                                content:this.editDialog.form.content,
                                icon:this.editDialog.form.icon,
                            }
                            cashbackDescribeAdd(obj)
                                .then(
                                    (res) => {
                                        Message({
                                            message: `${res.message}`,
                                            type: "success",
                                            duration: 800,
                                            onClose: () => {
                                                console.log("res", res);
                                                loading.close();
                                                this.editDialog.visible = false;
                                                this.tableGetList(this.table.searchForm);
                                            },
                                        });
                                    },
                                    (res) => {
                                        Message({
                                            message: `${res.message}`,
                                            type: "error",
                                            duration: 1500,
                                            onClose: () => {
                                                loading.close();
                                            },
                                        });
                                    }
                                )
                                .catch((error) => {
                                    console.log(error);
                                });
                        } else if (this.editDialog.operation == "edit") {
                            //数据处理
                            let obj = {
                                id:this.editDialog.form.id,
                                title:this.editDialog.form.title,
                                content:this.editDialog.form.content,
                                percentage:this.editDialog.form.percentage/100,
                            }
                            cashbackDescribeEdit(obj)
                                .then(
                                    (res) => {
                                        Message({
                                            message: `${res.message}`,
                                            type: "success",
                                            duration: 800,
                                            onClose: () => {
                                                console.log("res", res);
                                                loading.close();
                                                this.editDialog.visible = false;
                                                this.tableGetList(this.table.searchForm);
                                            },
                                        });
                                    },
                                    (res) => {
                                        Message({
                                            message: `${res.message}`,
                                            type: "error",
                                            duration: 1500,
                                            onClose: () => {
                                                loading.close();
                                            },
                                        });
                                    }
                                )
                                .catch((error) => {
                                    this.$message({
                                        showClose: true,
                                        message: error instanceof Object && error.message !== undefined ? error.message : "Cannot parse response",
                                        type: "error",
                                        onClose() {},
                                    });
                                });
                        }
                    }
                });
            },
            editStatus(row, value) {
                const loading = this.$loading({
                    lock: true,
                    text: "正在处理...",
                });
                serviceEdit({ ...row, status: value }).then(
                    (res) => {
                        console.log("res", res);
                        loading.close();
                        this.tableGetList(this.table.searchForm);
                    },
                    (res) => {
                        Message({
                            message: res.message,
                            type: "error",
                            duration: 1500,
                            onClose: () => {
                                loading.close();
                            },
                        });
                    }
                );
            },
            serviceDelete(row) {
                this.$confirm("确定进行删除操作吗?", "Tips", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                }).then(
                    () => {
                        const loading = this.$loading({
                            lock: true,
                            text: "正在处理...",
                        });
                        serviceDelete(row).then(
                            (res) => {
                                loading.close();
                                this.$message({
                                    message: res.message,
                                    type: "success",
                                });
                                this.tableGetList(this.table.searchForm);
                            },
                            (res) => {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "error",
                                    onClose() {
                                        loading.close();
                                    },
                                });
                            }
                        );
                    },
                    () => {}
                );
            },
            // 表格: 列表查询方法
            tableGetList(searchForm) {
                searchcashbackDescribe(searchForm.createTime ? { ...searchForm, createTime: `${searchForm.createTime[0]},${searchForm.createTime[1]}` } : { ...searchForm })
                    .then(
                        (res) => {
                            this.table.total = res.data.total;
                            this.table.tableList = res.data.list;
                            console.log("this.table.tableList", this.table.tableList);
                        },
                        (res) => {
                            Message({
                                message: `${res.message}`,
                                type: "error",
                                duration: 1500,
                            });
                        }
                    )
                    .catch((error) => {
                        Message({
                            message: `${error}`,
                            type: "error",
                            duration: 1500,
                        });
                    });
            },
            // 表格: 点击重置搜索条件时
            tableResetForm() {
                this.table.searchForm = {
                    pageNo: 1,
                    pageSize: 10,
                };
                this.tableGetList(this.table.searchForm);
            },
            // 表格: 点击表格的行时
            tableHandleRowClick(row, column, event) {
                this.$refs.table.toggleRowSelection(row);
            },
            // 表格: 点击搜索按钮时
            tableSearch() {
                console.log(this.table.searchForm);
                this.tableGetList(this.table.searchForm);
            },
            // 分页器: 每页条数发生变化时
            pagerHandleSizeChange(val) {
                this.table.searchForm.pageSize = val;
                this.tableGetList(this.table.searchForm);
            },
            // 分页器: 翻页时
            pagerHandleCurrentChange(val) {
                this.table.searchForm.pageNo = val;
                this.tableGetList(this.table.searchForm);
            },
        },
    };
</script>
<style lang="scss" scoped>
    .title {
        display: flex;
        justify-content: space-between;
        padding-right: 10px 10px;
        margin-left: 10px;
        border-bottom: 1px solid #dcdfe6;
        margin-bottom: 10px;
        h4 {
            margin: 0;
            font-size: 14px;
            color: #333;
            padding-bottom: 10px;
            border-bottom: 2px solid rgb(166, 59, 58);
        }
    }
    .searchBox {
        display: flex;
        .searchBtnBox {
            padding-left: 10px;
            // margin-left: 10px;
            ::v-deep .el-form-item--mini.el-form-item,
            ::v-deep .el-form-item--small.el-form-item {
                margin-bottom: 6px !important;
            }
        }
        .inpBox {
            ::v-deep .el-form-item--mini.el-form-item,
            ::v-deep .el-form-item--small.el-form-item {
                margin-bottom: 6px !important;
            }
            ::v-deep .el-form-item.long {
                width: 100%;
                margin-right: 0 !important;
            }
            ::v-deep .el-input__inner {
                width: 150px !important;
            }
            ::v-deep .el-date-editor {
                width: 350px !important;
            }
        }
    }
    .table {
        ::v-deep .el-table {
            color: #333;
            th {
                background-color: #f5f5f5;
                height: 40px;
                color: #333333 !important;
                padding: 2px 0 !important;
                &:first-child .cell {
                    padding: 0 10px 0 10px;
                }
            }
            tr {
                height: 32px;
                &:nth-child(even) {
                    background-color: #f8fafd;
                }
            }
            td {
                padding: 2px 0 !important;
            }
            .cell {
                text-align: center;
                padding: 0 10px;
            }
            .el-button--primary {
                background-color: rgb(166, 59, 58);
            }
            .el-button--primary:focus,
            .el-button--primary:hover {
                background: rgb(166, 59, 58);
                border-color: rgb(166, 59, 58);
                color: #fff;
            }
            .el-button {
                padding: 7px 15px;
            }
            .el-button--text {
                padding: 0;
            }
            .bigBtn {
                padding: 12px 28px;
            }
            .el-button--text {
                color: rgb(24, 148, 219);
            }
            .el-button--text:focus,
            .el-button--text:hover {
                color: rgb(24, 148, 219);
            }
            .el-table__body tr.hover-row > td {
                background-color: rgba(24, 148, 219, 0.3) !important;
            }
            .el-table__body tr.current-row > td {
                background-color: rgba(24, 148, 219, 0.3) !important;
            }
            .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: rgba(24, 148, 219, 0.3) !important;
            }
        }
    }
    .el-dialog__wrapper {
        ::v-deep .el-dialog__header {
            padding: 8px 20px !important;
            background-color: rgb(166, 59, 58);
            .el-dialog__title {
                color: #fff;
            }
            .el-dialog__headerbtn {
                top: 12px;
                .el-dialog__close {
                    color: #fff;
                }
            }
        }
        .hidden ::v-deep .el-upload--picture-card {
            display: none;
        }
        .addressBox .title {
            margin-top: 0;
            margin-left: 10px;
            font-size: 14px;
            margin-bottom: 20px;
            .iconFont {
                color: rgb(166, 59, 58);
                margin-right: 4px;
                font-size: 14px;
            }
        }
        ::v-deep .el-upload--picture-card {
            background-image: url("../../assets/images/upload.png");
            background-size: 130%;
            background-position: 50% 50%;
        }
    }
    .ql-editor{
      height:300px;
  }
</style>
